// extracted by mini-css-extract-plugin
export default {"container":"Counter_container__16KPJ","text":"Counter_text__8LnOT"};